import { useRouter } from 'next/router'
import { FC, useEffect } from 'react'
import clsx from 'clsx'

import { postAxiosSingle } from 'pages/api/axios'
import { cutHashFromURL } from 'utils/getURLData'
import { IObj } from 'constants/types/common.types'
import { URL_LIST } from 'constants/url'
import { YA_PAY_MERCHANT_ID, YA_PAY_ENVIRONMENT } from 'constants/data'
import WidgetYaPayThemes from './data'

import styles from './widget-ya-pay.module.scss'

interface IButtonYaPay {
  PaymentData?: IObj<string | number>
  onPayButtonClickHandler: any
  isButtonDisabled: boolean
  emaileValue: string
  mode?: string
}

const ButtonYaPay: FC<IButtonYaPay> = ({
  isButtonDisabled,
  PaymentData,
  onPayButtonClickHandler,
  emaileValue,
  mode = WidgetYaPayThemes.BUTTON,
}) => {
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)

  useEffect(() => {
    const buttonContainer = document.querySelector('#button_container')
    const YaPay = (window as any).YaPay
    console.log({ YaPay })
    let activeSession: any = null

    const createPaymentButton = () => {
      console.log('createPaymentButton:::')
      if (activeSession) {
        activeSession.mountWidget(buttonContainer, {
          widgetType: YaPay.WidgetType[mode],
          bnplSelected: true,
          borderRadius: 10,
        })
      }
    }

    const onYaPayLoad = () => {
      console.log({ YA_PAY_ENVIRONMENT })
      // Данные платежа
      const paymentData = {
        env: YaPay.PaymentEnv.Production,
        version: 4,
        currencyCode: YaPay.CurrencyCode.Rub,
        merchantId: YA_PAY_MERCHANT_ID,
        totalAmount: String(Number(PaymentData?.amount || 0) / 100) || '0',
        availablePaymentMethods: ['CARD', 'SPLIT'],
      }

      const onPayButtonClick = async () => {
        onPayButtonClickHandler && (await onPayButtonClickHandler())
        // Создание заказа...
        const { data } = await postAxiosSingle(
          URL_LIST.PAYMENT_NEW,
          {},
          { ...PaymentData, paymentService: 'yandex', path, email: emaileValue }
        )
        return data?.redirectURL
      }

      const onFormOpenError = (reason: string) => {
        console.error(`Payment error — ${reason}`)
      }

      // Создаем платежную сессию
      YaPay.createSession(paymentData, {
        onPayButtonClick: onPayButtonClick,
        onFormOpenError: onFormOpenError,
      })
        .then(function (paymentSession: any) {
          // Показываем кнопку Яндекс Пэй на странице.
          activeSession = paymentSession
          createPaymentButton()
        })
        .catch(function (err: any) {
          // Не получилось создать платежную сессию.
          console.log(`Error while trying to create payment session: ${JSON.stringify(err)}`)
        })
    }

    const resetPaymentButton = () => {
      if (activeSession) activeSession.unmountWidget(buttonContainer)
    }

    if (YaPay) {
      onYaPayLoad()
      return () => resetPaymentButton()
    }
  }, [PaymentData])

  return (
    <div
      className={clsx(styles.yaWidgetFullWidth, { [styles.yaWidgetDisabled]: isButtonDisabled })}
    >
      <div className={styles.yaWidgetFullWidth} id="button_container"></div>
    </div>
  )
}

export default ButtonYaPay
